import { useContext } from 'react';
import Maybe from 'true-myth/maybe';

import { ApplicationContext } from '../../../../shared/source/context/context';

type Tab = {
    readonly key: string;
};

export const useNavigationTabs = <T extends Tab>(
    tabs: readonly T[],
): {
    readonly currentTab: Maybe<T>;
    readonly currentTabIndex: number;
} => {
    const { applicationState } = useContext(ApplicationContext);
    const tabKey = applicationState.locationSearchParams.get('tab') ?? '';
    const tabIndex = tabs.findIndex((tab) => tab.key === tabKey);
    const sanitizedIndex = Math.max(0, tabIndex);

    return { currentTab: Maybe.of(tabs[sanitizedIndex]), currentTabIndex: sanitizedIndex };
};
